import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/fund/credit_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-bfbc4560"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "recharge-content rel" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-chongzhijilu" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "recharge-line" }, null, -1))
const _hoisted_4 = { class: "bank-card-tip" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://www.jetro.go.jp/world/asia/cn/holiday.html"
}, "→中国の祝日", -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"red"} }, "After you send the payment, please kindly contact the manager and share the payment screenshot, so we can following up on the payment progress and inform you, thank you so much for your cooperation.", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"red"} }, "Please add this in remark: payment send from XXX(your full name). For example: payment send from Alex Martin.", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "잔액 환불 주의 사항:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "중국 은행의 당일 환율에 따라 계산", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "구체적인 절차는 페이지 오른쪽에 있는 도움말 → 자금 관련에서 확인하시기 바랍니다", -1))
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  class: "back-card flex",
  style: {"margin-top":"14px"}
}
const _hoisted_17 = {
  key: 0,
  style: {"line-height":"17px","font-size":"12px","margin-top":"6px","color":"#666666"}
}
const _hoisted_18 = {
  key: 0,
  class: "infoWrap"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Only supports USD payment,if it is in other currencies, please convert it into US dollars before paying!"),
  /*#__PURE__*/_createElementVNode("div", { class: "info" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "infoItem" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Account Name"),
      /*#__PURE__*/_createElementVNode("span", { class: "value" }, "HONG KONG LORO BRAND MANAGEMENT CO., LIMITED")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "infoItem" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Account Number"),
      /*#__PURE__*/_createElementVNode("span", { class: "value" }, "20000013075306")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "infoItem" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "label" }, "ACH Routing Number"),
      /*#__PURE__*/_createElementVNode("span", { class: "value" }, "028000024")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "infoItem" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Wire Routing Number"),
      /*#__PURE__*/_createElementVNode("span", { class: "value" }, "021000021")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "infoItem" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "label" }, "SWIFT/BIC"),
      /*#__PURE__*/_createElementVNode("span", { class: "value" }, "CHASUS33")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "infoItem" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Bank Name"),
      /*#__PURE__*/_createElementVNode("span", { class: "value" }, "JP MORGAN CHASE BANK, N.A.")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "infoItem" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Bank Address"),
      /*#__PURE__*/_createElementVNode("span", { class: "value" }, "4 NEW YORK PLAZA FLOOR 15, New York, United States")
    ])
  ])
], -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { style: {"vertical-align":"middle"} }
const _hoisted_22 = { style: {"width":"200px"} }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-tishi1",
  style: {"cursor":"pointer","font-size":"14px","margin-left":"4px"}
}, null, -1))
const _hoisted_24 = { style: {"margin-bottom":"100px"} }
const _hoisted_25 = {
  class: "pay-content",
  style: {"margin-top":"10px"}
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fast-bank-banner flex-ter" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, "簡単でスピーディー；即入金可能；振込手数料3.4%")
  ])
], -1))
const _hoisted_27 = {
  class: "pay-content rel",
  style: {"margin-top":"28px"}
}
const _hoisted_28 = { style: {"margin-bottom":"100px","margin-top":"20px"} }
const _hoisted_29 = { class: "payoneer flex" }
const _hoisted_30 = {
  key: 0,
  class: "flex-end btn-setting"
}
const _hoisted_31 = {
  class: "flex-center",
  style: {"width":"100%","height":"100%","border-top":"1px solid #F9F9F9"}
}
const _hoisted_32 = { style: {"flex":"1"} }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-dianjixiazai" }, null, -1))
const _hoisted_34 = { class: "text" }

import { t } from '@/plugins/i18n'
import dayjs from 'dayjs'
import { ref, reactive, toRaw, nextTick, computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import Upload from '@/components/common/UploadNew.vue'
import DownLoadDialog from './downLoadDialog.vue'
import { rechargeApply, rechargeGet, uploadVoucher } from '@/apis/fund'
import { FormInstance, ElMessage } from 'element-plus'
import { clearForm } from '@/util/common'
import CreditCardPay from './CreditCardPay.vue'
import PaypalRecharge from './PaypalRecharge.vue'
import GuideModal from '@/components/NoviceGuide/index/index.vue'
import { getBlankGuideList } from '@/components/NoviceGuide/index/data'
import BackLink from '@/components/common/BackLink.vue'
import CheckRadio from './components/checkRadio.vue'
import FastBankPay from './components/FastBankPay.vue'
import RechargeHistory from './components/RechargeHistory.vue'
import { isD2C, useRtfix, useSite, useSite2Station, isJA, isEN, isKO, isMultiStore } from '@/store'
import { setTimeout } from 'timers'
import { Site } from '@/common/const'
import { getCountryCurrency, floatingRate, floatingRateKrw } from '@/util/useYan'
import confirmDialog from '@/components/common/ConfirmDialog'

export default /*#__PURE__*/_defineComponent({
  emits: ['update:visible', 'refresh'],
  setup(__props, { emit }) {

const router = useRouter()
const visible = ref(true)
const guideModal = ref()
const historyTable = ref()
const pageData = ref({
  page: 1,
  limit: 10
})

pageData.value = {
  page: 1,
  limit: 10
}

const store = useStore()
const isSub = store.getters.isSub
if (isSub) {
  // 如果是子账户回到首页
  router.replace('/')
}
const scrollBar = ref()
const setScroll = (scrollTop: number) => {
  scrollBar.value.setScrollTop(scrollTop)
}
const changeFile = (file: any) => {
  bankForm.voucherUrl = file?.raw.url ?? ''
  nextTick(() => {
    if (!bankFormRef.value) return
    bankFormRef.value.clearValidate(['voucherUrl'])
  })
}

const activeTab: any = ref('bankCard')
const bankNameShowTitle = ref(t('みずほ銀行'))
const bankForm: any = reactive({
  remitterName: '',
  remitterBankName: '',
  remittanceAmount: '',
  remittanceTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
  voucherUrl: '',
  remittanceCurrencyCode: '',
  acceptBankName: ''
})

const bankFormRules: any = {
  remitterName: [
    { required: true, message: t('必填'), trigger: 'blur' }
  ],
  remitterBankName: [
    { required: true, message: t('必填'), trigger: 'blur' }
  ],
  remittanceAmount: [
    { required: true, message: t('必填'), trigger: 'blur' },
    {
      validator: (rule: any, val: any, callback: any) => {
        if (Number(val) > 0) {
          callback()
        } else {
          callback(t('汇款金额必须大于0'))
        }
      },
      trigger: 'blur'
    }
  ],
  // remittanceTime: [
  //   { required: true, message: t('必填'), trigger: 'blur' }
  // ],
  voucherUrl: [
    { required: true, message: t('必填'), trigger: 'change' }
  ]
}

const changeBankPrice: any = (row: any) => {
  const matchArr = row.remittanceAmount.toString().match(/^\d{1,9}(\.\d{0,2})?/g)
  const num = (matchArr && matchArr[0]) || ''
  row.remittanceAmount = num
}

const payoneerForm = reactive({
  remitterCompanyName: '',
  remitterWebsiteUrl: '',
  remitterSurname: '',
  remitterName: '',
  remitterEmail: '',
  remitterNation: '',
  remittanceAmount: '',
  remittanceCurrencyCode: ''
})

const payoneerFormRules: any = {
  remitterCompanyName: [
    { required: true, message: t('必填'), trigger: 'blur' }
  ],
  remitterWebsiteUrl: [
    { required: true, message: t('必填'), trigger: 'blur' }
  ],
  remitterSurname: [
    { required: true, message: t('必填'), trigger: 'blur' }
  ],
  remitterName: [
    { required: true, message: t('必填'), trigger: 'blur' }
  ],
  remitterEmail: [
    { required: true, message: t('必填'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (!/[\d\w-]+@([a-zA-ZA-z0-9-]+\.)+[a-z]+/.test(val)) {
          callback(t('邮箱格式不正确，请重新输入'))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ],
  remitterNation: [
    { required: true, message: t('必填'), trigger: 'blur' }
  ],
  remittanceAmount: [
    { required: true, message: t('必填'), trigger: 'blur' },
    {
      validator: (rule: any, val: any, callback: any) => {
        if (Number(val) > 0) {
          callback()
        } else {
          callback(t('汇款金额必须大于0'))
        }
      },
      trigger: 'blur'
    }
  ]

}

const paypalPrice = ref()

const inputPrice: any = (row: any) => {
  paypalPrice.value = paypalPrice.value.toString().match(/^\d*(\.?\d{0,2})/g)[0]
}

const changePrice: any = (e: any) => {
  const num = paypalPrice.value.toString().match(/^\d*(\.?\d{0,2})/g)[0]
  paypalPrice.value = num ? Number(num) : ''
}

const bankFormRef = ref<FormInstance>()
const payoneerFormRef = ref<FormInstance>()
const submitLoading = ref(false)
const creditCardPay = ref()
const submit = () => {
  switch (activeTab.value) {
    case 'bankCard':
      // 普通银行转账
      if (!bankFormRef.value) return
      bankFormRef.value.validate((valid) => {
        if (valid) {
          bankCardPay()
        } else {
          return false
        }
      })
      break
    case 'fastBankCard':
      // 快捷银行转账
      fastBankPay.value.submit()
      break

    case 'payoneer':
      if (!payoneerFormRef.value) return
      payoneerFormRef.value.validate((valid) => {
        if (valid) {
          payoneerPay()
        } else {
          return false
        }
      })
      break
    case 'paypalCredit':
      creditCardPay.value.submit()
      break
  }
}

const clear = () => {
  clearForm(bankForm)
  clearForm(payoneerForm)
  paypalPrice.value = ''
  bankForm.remittanceTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
  bankForm.acceptBankName = t('みずほ銀行')
  bankForm.remittanceCurrencyCode = getCountryCurrency()

  // 汇款币种代码，暂时未使用。原支付逻辑已注释
  payoneerForm.remittanceCurrencyCode = 'USD'
}

const bankCardPay = () => {
  // 韩国银行暂时写死为韩亚银行
  submitLoading.value = true
  rechargeApply({
    ...toRaw(bankForm),
    payChannel: 1,
    customerName: store.getters.user.customerName,
    customerId: store.getters.user.customerId,
    systemSource: store.getters.plat === 'd2c' ? 1 : 2,
    acceptBankName: t('みずほ銀行'),
    rechargeCurrencyCode: currencyCode.value
  }).then((res: any) => {
    if (res.success) {
      ElMessage({
        message: t('提交成功2'),
        type: 'success',
        dangerouslyUseHTMLString: true
      })
      bankForm.voucherUrl = ''
      visible.value = false
      emit('refresh')
      emit('update:visible', false)
      setTimeout(() => {
        visible.value = true
      }, 100)
      setTimeout(() => {
        submitLoading.value = false
        visible.value = true
      }, 1000)
    } else {
      submitLoading.value = false
    }
  }).catch(() => { submitLoading.value = false })
}

const payoneerPay = () => {
  submitLoading.value = true
  rechargeApply({
    ...toRaw(payoneerForm),
    payChannel: 3,
    customerName: store.getters.user.customerName,
    customerId: store.getters.user.customerId,
    remittanceTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    systemSource: store.getters.plat === 'd2c' ? 1 : 2
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('提交成功'))
      emit('refresh')
      emit('update:visible', false)
      setTimeout(() => { submitLoading.value = false }, 1000)
    } else {
      submitLoading.value = false
    }
  }).catch(() => { submitLoading.value = false })
}

const downLoadDialog = ref()
// 下载弹窗
const openDownloadDialog = (status: any) => {
  downLoadDialog.value.open(activeTab.value === 'fastBankCard' ? 5 : activeTab.value === 'bankCard' ? 1 : (activeTab.value === 'paypal' || activeTab.value === 'paypalCredit') ? 2 : activeTab.value === 'payoneer' ? 3 : '')
}

const payFinish = () => {
  emit('update:visible', false)
  emit('refresh')
}

const route = useRoute()
// 币种
const currencyCode = computed(() => {
  const { currencyCode = 'CNY' } = route.query
  // 如果没开通多仓，直接展示人民币
  if (!isMultiStore()) return 'CNY'
  return currencyCode
})

clear()
rechargeGet({
  customerId: store.getters.user.customerId,
  payChannel: 3,
  rechargeCurrencyCode: currencyCode.value
}).then(res => {
  if (res.success && res.data) {
    payoneerForm.remitterCompanyName = res.data.remitterCompanyName
    payoneerForm.remitterWebsiteUrl = res.data.remitterWebsiteUrl
    payoneerForm.remitterSurname = res.data.remitterSurname
    payoneerForm.remitterName = res.data.remitterName
    payoneerForm.remitterEmail = res.data.remitterEmail
    payoneerForm.remitterNation = res.data.remitterNation
    payoneerForm.remittanceAmount = res.data.remittanceAmount
  }
})
rechargeGet({
  customerId: store.getters.user.customerId,
  payChannel: 1,
  rechargeCurrencyCode: currencyCode.value
}).then(res => {
  if (res.success && res.data) {
    bankForm.remitterName = res.data.remitterName
    // bankForm.remittanceTime = res.data.remittanceTime
    bankForm.remittanceAmount = res.data.remittanceAmount
    bankForm.remitterBankName = res.data.remitterBankName
  }
})
const radioValue = ref(0)
const rechargeHistoryRef = ref()
const fastBankPay = ref()
const showGuideModal = ref(false)
const guideList: any = ref([])
const showChange = (val: any, index: number) => {
  // 展示引导时触发展开收账户信息
  if (radioValue.value === 0) {
    setTimeout(() => {
      if (index === 1 || index === 0) {
        fastBankPay.value.visible = true
      } else {
        fastBankPay.value.visible = false
      }
      if (index === 1) {
        setScroll(200)
        guideList.value = getBlankGuideList()
      }
      setTimeout(() => {
        guideList.value = getBlankGuideList()
        showGuideModal.value = true
      }, 500)
    }, 100)
  }
}

const nextGuide = (index: number) => {
  if (index === 2) {
    fastBankPay.value.visible = false
  }
  if (index === 3) {
    setScroll(250)
    guideList.value = getBlankGuideList()
  }
}
const overGuide = () => {
  setScroll(0)
  fastBankPay.value.visible = true
}
const cancel = () => {
  router.push(useRtfix('CustomerFund', { query: { currencyCode: currencyCode.value } }))
}
const pageHeight = ref(document.documentElement.clientHeight - 72)
const onResize = () => {
  pageHeight.value = document.documentElement.clientHeight - 72
}
// 监听页面变化
window.addEventListener('resize', onResize)

// 清空状态
// store.dispatch('guide/resetGuide')

const cnyAmount = computed(() => {
  const isShowKR = currencyCode.value === 'KRW' && isMultiStore()
  //   如果该账号支持韩元钱包，且用韩元钱包充值
  const floatingRateVal = isShowKR ? floatingRateKrw.value : floatingRate.value
  let value = Math.floor(bankForm.remittanceAmount / floatingRateVal * 100) / 100
  //   韩元取整，舍弃小数
  if (isShowKR) {
    value = parseInt(String(value))
  }

  return value
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_scrollbar, {
      class: "recharge-container",
      "min-height": pageHeight.value + 'px',
      ref: (_value, _refs) => {
        _refs['scrollBar'] = _value
        scrollBar.value = _value
      }
    }, {
      default: _withCtx(() => [
        _createVNode(BackLink),
        _createElementVNode("div", {
          class: _normalizeClass(["recharge", _unref(useSite)()])
        }, [
          _createElementVNode("span", {
            class: "custom-tabs-label",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (rechargeHistoryRef.value.open()))
          }, [
            _hoisted_2,
            _createElementVNode("span", null, _toDisplayString(_unref(t)('充值记录')), 1)
          ]),
          _hoisted_3,
          _createVNode(_component_el_tabs, {
            modelValue: activeTab.value,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((activeTab).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: _unref(t)('銀行振込') + '（' + bankNameShowTitle.value + '）',
                name: "bankCard"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    (_unref(isJA)())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('入金反映：約1営業日')), 1),
                          _createElementVNode("div", null, [
                            _createTextVNode(_toDisplayString(_unref(t)('※週末、祝日・振替休日の振込は、翌営業日扱いとなります。')) + " ", 1),
                            _hoisted_6
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(isEN)())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
                      : _createCommentVNode("", true),
                    (_unref(isKO)())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_15))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_el_form, {
                      "label-width": "180px",
                      model: _unref(bankForm),
                      rules: bankFormRules,
                      ref: (_value, _refs) => {
                        _refs['bankFormRef'] = _value
                        bankFormRef.value = _value
                      },
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('汇款人姓名'),
                          prop: "remitterName",
                          style: {"width":"560px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(bankForm).remitterName,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bankForm).remitterName) = $event)),
                              maxlength: 20
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('银行名'),
                          prop: "remitterBankName",
                          style: {"width":"560px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(bankForm).remitterBankName,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bankForm).remitterBankName) = $event)),
                              maxlength: 10
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('金额'),
                          prop: "remittanceAmount",
                          style: {"width":"560px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(bankForm).remittanceAmount,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bankForm).remittanceAmount) = $event)),
                              onInput: _cache[4] || (_cache[4] = ($event: any) => (changeBankPrice(_unref(bankForm)))),
                              onChange: _cache[5] || (_cache[5] = ($event: any) => (changeBankPrice(_unref(bankForm))))
                            }, null, 8, ["modelValue"]),
                            (_unref(bankForm).remittanceAmount)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString((_unref(currencyCode) === 'KRW' && _unref(isMultiStore)() ? _unref(t)('预计到账KRW：X韩元') :
                      _unref(t)('预计到账CNY：X元')).replace('X', _unref(cnyAmount))), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('币种'),
                          style: {"width":"560px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(bankForm).remittanceCurrencyCode,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(bankForm).remittanceCurrencyCode) = $event)),
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        (_unref(isEN)())
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createVNode(_component_el_form_item, {
                                label: _unref(t)('弊社受取銀行')
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('みずほ銀行')), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              (_unref(isJA)())
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 0,
                                    label: _unref(t)('横浜駅前支店')
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(t)('店番292')), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["label"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_form_item, {
                                label: _unref(t)('口座番号')
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('普通預金 4014779')), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_form_item, {
                                label: _unref(t)('口座名')
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('株式会社 SNIFF JAPAN')), 1)
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ], 64)),
                        _createVNode(_component_el_form_item, { prop: "voucherUrl" }, {
                          label: _withCtx(() => [
                            _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(t)('汇款凭证')), 1),
                            _createVNode(_component_el_tooltip, {
                              class: "tool",
                              placement: "top",
                              effect: "light"
                            }, {
                              content: _withCtx(() => [
                                _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)('振込日、振込依頼人、お受取人名、振込金額の情報が含まれる画像をお願いします。')), 1)
                              ]),
                              default: _withCtx(() => [
                                _hoisted_23
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            (visible.value)
                              ? (_openBlock(), _createBlock(Upload, {
                                  key: 0,
                                  "limit-file": { accept: '.jpg,.jpeg,.png,.JPG,.JPEG,.PNG,.pdf' },
                                  onChange: changeFile,
                                  readAuto: true,
                                  bizType: "recharge"
                                }, null, 8, ["limit-file"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    (activeTab.value !== 'paypal')
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          onClick: cancel,
                          style: {"width":"90px","height":"40px"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (activeTab.value !== 'paypal')
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "primary",
                          loading: submitLoading.value,
                          onClick: submit,
                          style: {"width":"90px","height":"40px"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('提交')), 1)
                          ]),
                          _: 1
                        }, 8, ["loading"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["label"]),
              (_unref(isJA)())
                ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                    key: 0,
                    label: "paypal",
                    name: "paypal"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_25, [
                        (activeTab.value === 'paypal')
                          ? (_openBlock(), _createBlock(PaypalRecharge, {
                              key: 0,
                              onClose: cancel,
                              onRefresh: payFinish
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(isJA)())
                ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                    key: 1,
                    label: _unref(t)('paypal信用卡'),
                    name: "paypalCredit"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_26,
                      _createElementVNode("div", _hoisted_27, [
                        (activeTab.value === 'paypalCredit')
                          ? (_openBlock(), _createBlock(CreditCardPay, {
                              key: 0,
                              onClose: cancel,
                              onDownload: openDownloadDialog,
                              type: "recharge",
                              onSuccess: payFinish,
                              ref: (_value, _refs) => {
                                _refs['creditCardPay'] = _value
                                creditCardPay.value = _value
                              }
                            }, null, 512))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_28, [
                          (activeTab.value !== 'paypal')
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                onClick: cancel,
                                style: {"width":"90px","height":"40px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (activeTab.value !== 'paypal')
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 1,
                                type: "primary",
                                loading: submitLoading.value,
                                onClick: submit,
                                style: {"width":"90px","height":"40px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('提交')), 1)
                                ]),
                                _: 1
                              }, 8, ["loading"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true),
              false
                ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                    key: 2,
                    label: "payoneer",
                    name: "payoneer"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_el_form, {
                          "label-width": "190px",
                          model: _unref(payoneerForm),
                          rules: payoneerFormRules,
                          ref: (_value, _refs) => {
                            _refs['payoneerFormRef'] = _value
                            payoneerFormRef.value = _value
                          },
                          style: {"max-width":"460px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: _unref(t)('公司名称'),
                              prop: "remitterCompanyName"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _unref(payoneerForm).remitterCompanyName,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(payoneerForm).remitterCompanyName) = $event)),
                                  placeholder: _unref(t)('如果是个人，请输入无')
                                }, null, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_form_item, {
                              label: _unref(t)('店铺主页入口'),
                              prop: "remitterWebsiteUrl"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _unref(payoneerForm).remitterWebsiteUrl,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(payoneerForm).remitterWebsiteUrl) = $event)),
                                  placeholder: _unref(t)('如果是个人，请输入无')
                                }, null, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_form_item, {
                              label: _unref(t)('姓氏'),
                              prop: "remitterSurname"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _unref(payoneerForm).remitterSurname,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(payoneerForm).remitterSurname) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_form_item, {
                              label: _unref(t)('名字'),
                              prop: "remitterName"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _unref(payoneerForm).remitterName,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(payoneerForm).remitterName) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_form_item, {
                              label: _unref(t)('邮箱地址'),
                              prop: "remitterEmail"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _unref(payoneerForm).remitterEmail,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(payoneerForm).remitterEmail) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_form_item, {
                              label: _unref(t)('国际'),
                              prop: "remitterNation"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _unref(payoneerForm).remitterNation,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(payoneerForm).remitterNation) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_form_item, {
                              label: _unref(t)('存入金额'),
                              prop: "remittanceAmount"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _unref(payoneerForm).remittanceAmount,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(payoneerForm).remittanceAmount) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_form_item, {
                              label: _unref(t)('币种')
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _unref(payoneerForm).remittanceCurrencyCode,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(payoneerForm).remittanceCurrencyCode) = $event)),
                                  disabled: ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(DownLoadDialog, {
            ref: (_value, _refs) => {
              _refs['downLoadDialog'] = _value
              downLoadDialog.value = _value
            },
            currencyCode: _unref(currencyCode)
          }, null, 8, ["currencyCode"]),
          _createVNode(GuideModal, {
            ref: (_value, _refs) => {
              _refs['guideModal'] = _value
              guideModal.value = _value
            },
            name: _unref(isD2C)() ? 'd2c-recharge' : 'b2b-recharge',
            onShow: showChange,
            show: showGuideModal.value,
            list: guideList.value,
            onNext: nextGuide,
            onReturn: overGuide
          }, null, 8, ["name", "show", "list"])
        ], 2),
        _createVNode(RechargeHistory, {
          ref: (_value, _refs) => {
            _refs['rechargeHistoryRef'] = _value
            rechargeHistoryRef.value = _value
          }
        }, null, 512),
        (activeTab.value === 'paypalCredit' || activeTab.value === 'bankCard' || activeTab.value === 'paypal')
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", {
                    class: "upload-btn",
                    onClick: openDownloadDialog
                  }, [
                    _hoisted_33,
                    _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(t)('请求书下载')), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["min-height"])
  ]))
}
}

})